'use client';

import { Text, TextLevels } from '@bytel/trilogy-react-ts';

import { uiStore } from '@stores/ui';

function Loading() {
    const { loading } = uiStore();
    if (!loading.show) return null;
    return (
        <>
            <div className='btL level-item is-fullwidth has-background-white'>
                <div className='is-fullwidth level-item'>
                    <div className='loader'>
                        <div className='loader-body'></div>
                    </div>
                </div>

                <Text level={TextLevels.ONE} className='btLText has-text-centered'>
                    {loading.message}
                </Text>
            </div>
        </>
    );
}

export default Loading;
